import PropTypes from 'prop-types';

const DropDownIcon = props => (
  <svg className={props.className} xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11">
    <g fillRule="evenodd" transform="translate(-20 -23)">
      <path fill="#333" d="M35.235 23.635L37.286 25.686 29.01 33.961 20.735 25.686 22.786 23.635 29.01 29.86z" />
    </g>
  </svg>
);

DropDownIcon.propTypes = {
  className: PropTypes.string,
};

DropDownIcon.defaultProps = {
  className: '',
};

export default DropDownIcon;
